<template>
  <svg :width="size" :height="size" :viewBox="viewBox">
      <path d="M 25.496094 21.445312 C 25.5 21.460938 25.5 21.476562 25.5 21.492188 C 25.507812 22.328125 24.507812 23.335938 22.890625 24.113281 C 21.585938 24.746094 19.328125 25.5 16 25.5 C 12.671875 25.5 10.414062 24.746094 9.109375 24.113281 C 7.492188 23.335938 6.492188 22.328125 6.5 21.492188 C 6.5 21.476562 6.5 21.460938 6.503906 21.445312 L 7.195312 15.226562 C 7.210938 15.085938 7.289062 14.964844 7.410156 14.894531 C 7.53125 14.824219 7.679688 14.820312 7.808594 14.875 L 15.183594 18.179688 C 15.703125 18.414062 16.296875 18.414062 16.816406 18.179688 L 24.191406 14.875 C 24.320312 14.820312 24.46875 14.824219 24.589844 14.894531 C 24.710938 14.964844 24.789062 15.085938 24.804688 15.226562 Z M 29.6875 9.585938 L 16.816406 3.820312 C 16.296875 3.585938 15.703125 3.585938 15.183594 3.820312 L 2.3125 9.585938 C 1.953125 9.75 1.722656 10.105469 1.722656 10.5 C 1.722656 10.894531 1.953125 11.25 2.3125 11.414062 L 15.183594 17.179688 C 15.703125 17.414062 16.296875 17.414062 16.816406 17.179688 L 27.5 12.394531 L 27.5 16.136719 C 27.191406 16.3125 27 16.644531 27 17 L 27 23.5 L 29 23.5 L 29 17 C 29 16.644531 28.808594 16.3125 28.5 16.136719 L 28.5 11.945312 L 29.6875 11.414062 C 30.046875 11.25 30.277344 10.894531 30.277344 10.5 C 30.277344 10.105469 30.046875 9.75 29.6875 9.585938 Z M 29.6875 9.585938 "/>
  </svg>

</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 32
    },
    box: {
      type: [Number, String],
      default: 32
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.box} ${this.box}`
    }
  }
}
</script>